import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { useCallback } from 'react';
import React from 'react';
import { isProd } from '../../constant/app.constant';
export function SolanaProvider({ children }) {
  const onError = useCallback((error) => {
    console.error(error);
  }, []);

  return (
    <ConnectionProvider endpoint={isProd ? process.env.REACT_APP_SOLANA_RPC_MAINNET : process.env.REACT_APP_SOLANA_RPC_DEVNET}>
      <WalletProvider wallets={[]} onError={onError} autoConnect>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}
